import { createAuthStore, type AuthStatus } from '@jarvis/platform-ui';
import type { OpsRole } from './roles';
import { getHighestOpsRole } from './roles';

export type { AuthStatus };

interface AuthState {
  status: AuthStatus;
  username: string | null;
  displayName: string | null;
  roles: string[];
  highestOpsRole: OpsRole | null;
  setChecking: () => void;
  setAnonymous: () => void;
  setForbidden: () => void;
  setAuthenticated: (payload: {
    username: string | null;
    displayName: string | null;
    roles: string[];
  }) => void;
  reset: () => void;
}

export const useAuthStore = createAuthStore({
  highestRoleKey: 'highestOpsRole',
  getHighestRole: getHighestOpsRole
}) as unknown as import('zustand').UseBoundStore<import('zustand').StoreApi<AuthState>>;
